import Vue from "vue";
// eslint-disable-next-line no-unused-vars
import App from './App.vue'
import Test from './Test.vue'
import api from "@/js/api";
import config from "./config.json";
import u from '@/js/utils'
import adaptor from '@/js/dataAdaptor'

import VueRouter from 'vue-router'//引入
Vue.use(VueRouter)//应用
import router from './router'
import store from "./vuex";

//region element组件注册
import
{
    Form, FormItem, Select, Option, Switch, Input, Button, Drawer, Menu, MenuItem,
    MenuItemGroup, Submenu, Avatar, Table, TableColumn,Tooltip,
    Col, Aside, Main, Container, Header, Footer, Row, Pagination,
    Message, Loading, Result, Tag, Dialog, Collapse, Card,Image,Descriptions,
    DescriptionsItem,Link,Carousel,CarouselItem,Dropdown,DropdownMenu,DropdownItem
} from 'element-ui'

import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.component(Header.name,Header);
Vue.component(Row.name,Row);
Vue.component(Footer.name,Footer);
Vue.component(Form.name,Form);
Vue.component(FormItem.name,FormItem);
Vue.component(Select.name,Select);
Vue.component(Option.name,Option);
Vue.component(Switch.name,Switch);
Vue.component(Input.name,Input);
Vue.component(Button.name,Button);
Vue.component(Drawer.name,Drawer);
Vue.component(Menu.name,Menu);
Vue.component(MenuItem.name,MenuItem);
Vue.component(MenuItemGroup.name,MenuItemGroup);
Vue.component(Submenu.name,Submenu);
Vue.component(Avatar.name,Avatar);
Vue.component(Table.name,Table);
Vue.component(TableColumn.name,TableColumn);
Vue.component(Col.name,Col);
Vue.component(Aside.name,Aside);
Vue.component(Main.name,Main);
Vue.component(Container.name,Container);
Vue.component(Pagination.name,Pagination);
Vue.component(Result.name,Result);
Vue.component(Message.name,Message);
Vue.component(Tag.name,Tag);
Vue.component(Dialog.name,Dialog);
Vue.component(Collapse.name,Collapse);
Vue.component(Card.name,Card);
Vue.component(Image.name,Image);
Vue.component(Descriptions.name,Descriptions);
Vue.component(DescriptionsItem.name,DescriptionsItem);
Vue.component(CollapseTransition.name,CollapseTransition);
Vue.component(Link.name,Link);
Vue.component(Carousel.name,Carousel);
Vue.component(CarouselItem.name,CarouselItem);
Vue.component(Dropdown.name,Dropdown);
Vue.component(DropdownMenu.name,DropdownMenu);
Vue.component(DropdownItem.name,DropdownItem);
Vue.component(Tooltip.name,Tooltip);
Vue.use(Loading.directive);
Vue.config.productionTip = false
Vue.prototype.$message = message
//endregion

//region echarts专用
import * as echarts from 'echarts/core';// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import { BarChart,PieChart} from 'echarts/charts';// 引入柱状图图表，图表后缀都为 Chart
import {// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent
} from 'echarts/components';
import { LabelLayout, UniversalTransition } from 'echarts/features';// 标签自动布局，全局过渡动画等特性
import { CanvasRenderer } from 'echarts/renderers';// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步


echarts.use([// 注册必须的组件
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    BarChart,
    PieChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer
]);

//endregion

//region 注册自定义组件
    import modelframe from "@/components/modelframe";
import message from "element-ui/packages/message";
    Vue.component(modelframe.name,modelframe);
//endregion

//region 注册全局变量
Vue.prototype.$api = api;//接口
Vue.prototype.$u = u;//工具
Vue.prototype.$adaptor = adaptor;//数据适配器
Vue.prototype.$charts = echarts;
Vue.prototype.$config = config;//配置
// Vue.prototype.$store = store;

//endregion


let vm = new Vue({
  store,
  render: h => h(App),//正式
  // render: h => h(Test),
  router:router
})

vm.$mount('#app');
